/* global angular swal, _ */
import './style.less';
import usersCourseFinalModalTemplate from 'modals/selfStudyFInal/template.html';
import UsersCourseFinalModalController from 'modals/selfStudyFInal';

export default function(
  $state,
  $scope,
  $filter,
  $log,
  $q,
  $stateParams,
  $timeout,
  Swal,
  ProfileClass,
  $uibModal,
  ApiClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { profile } = ProfileClass.profileComplete;
  const profile_uid = $stateParams.employeeID || $stateParams.id || profile.profile_uid;

  const courseId = $stateParams.courseId;
  let profileComplete = false;
  const ansDict = {};

  const profileUpdate = () => {
    const obj = $uibModal.open({
      backdrop: true,
      template: usersCourseFinalModalTemplate,
      controller: UsersCourseFinalModalController
    });
    $q.all([obj.closed])
      .then(() => {
        ProfileClass.profileGet(profile_uid).then(profileData => {
          if (profileData.first && profileData.last) {
            profileComplete = true;
            return vm.finalQuiz();
          }
          swal('Oops...', 'Looks like your profile is incomplete!', 'error');
        });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.sorted = ['a', 'b', 'c', 'd'];

  vm.prev = () => $state.go('^.quiz', { moduleId: vm.progress.next });

  vm.formData = {};

  vm.finalQuiz = function() {
    if (!profileComplete) return profileUpdate();
    const questNum = _.size(ansDict);
    const numCorrect = _.values(vm.formData).filter((answer, i) => answer === ansDict[i]).length;
    let score = 0;

    if (!questNum) score = 100;
    else score = $filter('Progress')(numCorrect, questNum).toFixed(2);

    if (score < 80) return swal('Try Again!', `You got only ${score}%`, 'error');
    if (score >= 80 && vm.progress.cert) {
      return Swal.alert(
        'Great job!',
        `You got ${score}%! You already earned a certificate, so another will not be sent to you`
      )
        .then(() => $state.go('app.users.courses.course.progress'))
        .catch(error => {
          if (error.dismiss) return;
          $log.error(error);
          throw error;
        });
    }

    swal({
      title: 'Nice Work',
      text: `You passed with ${score}%. One moment while we prepare your certificate...`,
      type: 'success',
      allowOutsideClick: false,
      allowEscapeKey: false,
      animation: false,
      showConfirmButton: false
    });

    // TODO: remove colmpliance upate

    return ApiClass.coursesIdTypeTypeIdPatch({ id: courseId, type: 'progress', type_id: profile_uid }, { final: true })
      .then(() =>
        ApiClass.usersIdTypeGet(
          { id: profile_uid, type: 'licenses', manage: false },
          {},
          {
            queryParams: {
              data_type: 'update'
            }
          }
        )
      )
      .then(() => {
        Swal.toast('We have added your certificate to your profile and sent a copy to your email!');
        $state.go('app.users.courses.course.progress');
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    vm.loaded = false;
    vm.error = {};
    $q.all([
      ProfileClass.profileGet(profile_uid),
      ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { updateProgress: true } })
    ])
      .then(([profileData, { data: { course } }]) => {
        vm.course = course;
        vm.progress = vm.course.progress;
        vm.questions = vm.course.questionsArr;
        const viewQues = angular.copy(vm.course.questionsArr);

        viewQues.forEach((question, i) => {
          ansDict[i] = question.correct;
          delete question.correct;
        });

        vm.questions = viewQues;

        if (profileData.first && profileData.last) profileComplete = true;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selfStudy/final/controller.js